module.exports = __webpack_public_path__ + "static/project-briefing-form-b78c36c0c2fc1fcacfaa4ee4a7b2e193.pdf";